import axios from "axios";
import { useGlobalStore } from "../../context/UserContext/userContext";
import { refreshAccessToken } from "./tokenRefreshCoordinator";

export function createHttpClient({ baseURL, resolveBaseURL } = {}) {
  const client = axios.create(resolveBaseURL ? {} : { baseURL });

  client.interceptors.request.use(async (config) => {
    if (resolveBaseURL) {
      config.baseURL = resolveBaseURL();
    }
    const store = useGlobalStore.getState();
    const token = await store.getAccessToken();
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  // 401 → refresh → retry once
  client.interceptors.response.use(
    (res) => res,
    async (error) => {
      const status = error?.response?.status;
      const config = error?.config;
      if (status !== 401 || !config || config._retry) {
        return Promise.reject(error);
      }
      config._retry = true;

      const newToken = await refreshAccessToken();
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${newToken}`;
      return client.request(config);
    },
  );

  return client;
}

